import { BrowserModule, Title } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';

import { AppComponent } from './app.component';
import { UserManagementModule } from './userManagement/userManagement.module';
import { ErrorSnackBar } from './components/error-snack-bar/error-snack-bar.component';
import { ErrorSnackBarModule } from './components/error-snack-bar/error-snack-bar.module';
import { DesktopStorageService } from './services/storage.service';
import { DesktopHttpInterceptor } from './services/httpInterceptor.service';
import { DesktopErrorHandler } from './services/errorHandler.service';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { WebStorageModule } from '@efaps/ngx-store';


import {
  HuddyapiModule,
  BuildingState,
  ChatState,
  BulkSubscriptionState,
  EvaluationState,
  HuddyStateDefState,
  CompassState,
  FamilyState,
  UserSettingState,
  PatientState,
  GuidanceSubscriptionsState,
  ReminderState,
  MeasurementState,
  MiniTrackerState,
  AlertState,
  SchedulingState,
  PractitionerGroupState,
  ProviderEndpointState,
  DocumentState,
  ApplicationContextInterceptor,
  RefreshState,
  TimelineState,
  TrackableManagementState
} from 'huddyapi';
import { PatientsModule } from './patients/patients.module';
import { BuilderModule } from './builder/builder.module';
import { ConfirmationDialogModule } from './components/confirmation-dialog/confirmation-dialog.module';
import { AvatarModule } from './components/avatar/avatar.module';
import { SettingsModule } from './settings/settings.module';
import { CompassDetailModule } from './compass-detail/compass-detail.module';
import { CompassesModule } from './compasses/compasses.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileModule } from './profile/profile.module';
import { TextInputDialogModule } from './components/text-input-dialog/text-input-dialog.module';
import { OnboardingDialogModule } from './components/onboarding-dialog/onboarding-dialog.module';
import { ReviewModule } from './builder/review/review.module';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { PatientModule } from './patient/patient.module';
import { FamiliesModule } from './families/families.module';
import { FamilyDetailModule } from './family-detail/family-detail.module';
import { TodoComponentModule } from './todo/todo.module';
import { MatIconModule } from '@angular/material/icon';
import { ChatModule } from './components/chat/chat.component.module';
import { CommunityConfigService } from './services/community-config.service';
import { MatSelectModule } from '@angular/material/select';


@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [
        BrowserModule,
        ChatModule,
        UserManagementModule,
        MatSnackBarModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        WebStorageModule,
        FormsModule,
        ReactiveFormsModule,
        CompassDetailModule,
        FamilyDetailModule,
        PatientsModule,
        FamiliesModule,
        PatientModule,
        SettingsModule,
        BuilderModule,
        CompassesModule,
        ProfileModule,
        ReviewModule,
        TodoComponentModule,
        ErrorSnackBarModule,
        AvatarModule,
        CdkScrollableModule,
        HuddyapiModule.forRoot({}),
        RouterModule.forRoot([
            { path: '**', redirectTo: 'login' }
        ], { enableTracing: false }),
        BrowserAnimationsModule,
        NgxsModule.forRoot([
            AlertState,
            BuildingState,
            BulkSubscriptionState,
            ChatState,
            HuddyStateDefState,
            DocumentState,
            CompassState,
            FamilyState,
            EvaluationState,
            GuidanceSubscriptionsState,
            MeasurementState,
            PractitionerGroupState,
            ProviderEndpointState,
            UserSettingState,
            ReminderState,
            RefreshState,
            MiniTrackerState,
            SchedulingState,
            TimelineState,
            TrackableManagementState,
            PatientState
        ]),
        MatIconModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApplicationContextInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DesktopHttpInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useClass: DesktopErrorHandler
        },
        CommunityConfigService,
        DesktopErrorHandler,
        DesktopStorageService,
        ErrorSnackBar,
        Title,
        ConfirmationDialogModule,
        OnboardingDialogModule,
        TextInputDialogModule,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
